import React from 'react';
import { Props } from '../index';

const InterRegularText: React.FC<Props> = ({
  children,
  color,
  fontSize,
  textAlign,
  lineHeight,
  opacity,
  marginTop,
  marginBottom,
  marginLeft,
  paddingRight,
  paddingLeft,
  paddingTop,
  paddingBottom,
  width,
  maxWidth,
  minWidth,
  letterSpacing,
  position,
  textDecorationLine,
  showTextOverflow,
  padding,
  backgroundColor,
  borderRadius,
  isSpan,
  wordNewline,
  onClick,
}) => {
  const textOverflowStyle = {
    width: width != null ? width : 'inherit', // inherit：继承父节点的宽度
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const Element = isSpan ? 'span' : 'div';

  return (
    <Element
      style={{
        marginTop,
        marginBottom,
        marginLeft,
        fontFamily: 'Inter-Regular',
        color: color || '#000000',
        fontSize: fontSize || 14,
        textAlign,
        lineHeight: lineHeight != null ? lineHeight + 'px' : undefined,
        opacity,
        width,
        maxWidth,
        minWidth,
        position,
        textDecorationLine,
        paddingRight,
        paddingLeft,
        paddingTop,
        paddingBottom,
        letterSpacing,
        padding,
        backgroundColor,
        borderRadius,
        // 让文字自动换行
        wordWrap: 'break-word',
        wordBreak: wordNewline ? 'keep-all' : 'break-all',
        ...(showTextOverflow ? textOverflowStyle : {}),
      }}
      onClick={onClick}
    >
      {children}
    </Element>
  );
};

export default InterRegularText;
